<template lang="pug">
  section
    FinanceMasterImport(
      backUrlPath="/tms/management/payment-tariff-rule"
      :uploadFileUrl="getUploadFileUrl"
      :uploadValidationUrl="getUploadValidationUrl"
      :commit-import-url="getCommitImportUrl"
      :target-count-url="fetchWorkListCountUrl"
      :fetchWorkListUrl="fetchWorkListUrl"
      :uploaded-at-action="uploadedAtAction"
      :isFilterError="isFilterError"
      :toggleFilterAction="toggleFilter"
    )
      template(v-slot:table)
        PaymentTariffRuleImportWorkListTable(ref="WorkTable" :getListActionName="getListActionName" :isFilterError="isFilterError")
</template>

<script>
import PaymentTariffRuleImportWorkListTable from "@/components/management/payment-tariff-rule/PaymentTariffRuleImportWorkListTable";
import FinanceMasterImport from "@/components/import/FinanceMasterImport";
import AxiosBase from "@/assets/js/axios-base";
import { mapActions, mapGetters } from "vuex";

let axiosBase = new AxiosBase();

export default {
  components: {
    PaymentTariffRuleImportWorkListTable,
    FinanceMasterImport
  },
  methods: {
    ...mapActions("financeImport", {
      uploadFile: "uploadImportFile",
      commitImport: "commitImport",
      clearWorkData: "clearWorkData",
      fetchWorkList: "fetchWorkList",
      toggleErrorOnly: "toggleErrorOnly"
    }),
    uploadedAtAction() {
      this.toggleErrorOnly(false);
      this.$refs.WorkTable.loadUploadData();
    },
    toggleFilter() {
      this.toggleErrorOnly(!this.isFilterError);
      this.$refs.WorkTable.loadUploadData();
    }
  },
  computed: {
    ...mapGetters("financeImport", {
      isFilterError: "isFilterError"
    }),
    getListActionName: () => "financeImport/fetchWorkList",
    getUploadFileUrl: () => axiosBase.getUrls().uploadPaymentTariffRuleImportWork,
    getUploadValidationUrl: () => axiosBase.getUrls().uploadPaymentTariffRuleImportWorkValidation,
    getCommitImportUrl: () => axiosBase.getUrls().uploadPaymentTariffRuleImportWorkCommit,
    fetchWorkListUrl: () => axiosBase.getUrls().getPaymentTariffRuleWorkList,
    fetchWorkListCountUrl: () => axiosBase.getUrls().getPaymentTariffRuleWorkListCount
  }
};
</script>
